module.exports = __webpack_public_path__ + "img/458.ec1774cd.jpg";